import React, { useState, useEffect } from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';
import  {LanguageSwitcher}  from './LanguageSwitcher';

import { Navigator } from './Navigator';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

import { usePageLocale } from '../hooks/usePageLocale';

import logoWhite from '../assets/Logo.svg';
import logo from '../assets/LogoWhite.svg';

export default function Header() {
    const data = useStaticQuery(graphql`
        query HeaderQuery {
            allDatoCmsMenu {
              menuNodes: nodes {
                locale
                links {
                  id: originalId
                  name
                  link {
                    ... on DatoCmsHomepage {
                      id: originalId
                    }
                    ... on DatoCmsServiceRoot {
                      id: originalId
                    }
                    ... on DatoCmsAboutpage {
                      id: originalId
                    }
                    ... on DatoCmsContactpage {
                      id: originalId
                    }
                  }
                }
              }
            }
            allDatoCmsHomepage {
              homepageNodes: nodes {
                id: originalId
                locale
                seo {
                  title
                }
              }
            }
            allDatoCmsServiceRoot {
              serviceRootNodes: nodes {
                id: originalId
                locale
              }
            }
            allDatoCmsAboutpage {
              aboutpageNodes: nodes {
                id: originalId
                locale
              }
            }
            allDatoCmsContactpage {
              contactpageNodes: nodes {
                id: originalId
                locale
              }
            }
        } 
    `)   

    const {
      allDatoCmsMenu: { menuNodes },
      allDatoCmsHomepage: { homepageNodes },
      allDatoCmsServiceRoot: { serviceRootNodes },
      allDatoCmsAboutpage: { aboutpageNodes },
      allDatoCmsContactpage: { contactpageNodes },
    } = data;
  
    const { pageLocale } = usePageLocale();
  
    const homepageNodesMatch = homepageNodes.find(
      ({ locale }) => locale === pageLocale
    );

    const serviceRootNodesMatch = serviceRootNodes.find(
      ({ locale }) => locale === pageLocale
    );
    const aboutpageNodesMatch = aboutpageNodes.find(
      ({ locale }) => locale === pageLocale
    );
    const contactpageNodesMatch = contactpageNodes.find(
      ({ locale }) => locale === pageLocale
    );
  
    const menuNodesMatch = menuNodes.filter(
      ({ locale }) => locale === pageLocale
    );

    const {
      id: homepageRecordId,
      seo: { title: seoTitle },
    } = homepageNodesMatch;

    const {
      id: serviceRootRecordId,
    } = serviceRootNodesMatch;
    
    const {
      id: aboutpageRecordId,
    } = aboutpageNodesMatch;

    const {
      id: contactpageRecordId,
    } = contactpageNodesMatch;

    const [{ links: menuLinks }] = menuNodesMatch;
      
    const [navbar, setNavbar] = useState(false)
    const [text, setText] = useState(false)
    const [navbarLogo, setNavbarLogo] = useState(logo)

    const changeBackground = () => {
      console.log(window.scrollY)
      if (window.scrollY >= 10) {
        setNavbar(true)
      } else {
        setNavbar(false)
      }
    }
    useEffect(() => {
      changeBackground()
      window.addEventListener('scroll', changeBackground)
    })

    const changeText = () => {
      console.log(window.scrollY)
      if (window.scrollY >= 10) {
        setText(true)
      } else {
        setText(false)
      }
    }
    useEffect(() => {
      changeText()
      window.addEventListener('scroll', changeText)
    })

    const changeLogo = () => {
      if (window.scrollY >= 10) {
        setNavbarLogo(logoWhite)
      } else {
        setNavbarLogo(logo)
      }
    }
    useEffect(() => {
      changeLogo()
      window.addEventListener('scroll', changeLogo)
    })

    const [menuOpen, setMenuOpen] = useState(false);
    

    return (
      <nav className={navbar ? 'HeaderWrapper' : 'HeaderWrapperTop'} >

        <Navigator recordId={homepageRecordId}>
          <img src={navbarLogo} className="HeaderLogo" alt="logo" />
        </Navigator>

        <button
          className='HeaderHamburger'
          aria-label='Open Menu'
          onClick={() => { setMenuOpen(!menuOpen);}} >
          <Bars3Icon />
        </button>

        <div className={menuOpen ? 'HeaderNavContainerMobile' : ''}>
          <ul className={menuOpen ? 'HeaderNavUlMobile' : 'HeaderNavUl'}> 
            <button
              className='HeaderHamburger'
              aria-label='Open Menu'
              onClick={() => { setMenuOpen(!menuOpen);}} >
              <XMarkIcon />
            </button>
            {menuLinks.map(({ id, name, link }) =>
                <li className={menuOpen ? 'HeaderNavLiMobile' : 'HeaderNavLi'} key={id}>
                  <Navigator
                    recordId={link?.id}
                    className={text ? 'Nav' : 'NavTop'}
                    activeClassName={menuOpen ? 'NavActiveLinkMobile' : 'NavActiveLink'}
                  >
                    {name}
                  </Navigator>
                </li>
            )}
            
            <li className={menuOpen ? 'HeaderNavLiMobile' : 'HeaderNavLiLangSwitch'} >
              <LanguageSwitcher className='Nav' />
            </li>
          </ul>
        </div>
      </nav>
    )
  };

